(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-navbar"] && !Shopify.designMode) return;
  try {
    
function initialiseAEHeader(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const toggle = root.querySelector('.ae-header__toggle');
  const panel = root.querySelector('.ae-department-menu');
  const backdrop = root.querySelector('.ae-nav-backdrop');
  const closeButton = root.querySelector('.ae-drawer-close');
  const groups = [...root.querySelectorAll('.ae-header__group')];
  if (!toggle || !panel || !backdrop || !closeButton) return;
  const closeGroups = () => groups.forEach(group => { group.open = false; });
  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    root.toggleAttribute('data-menu-open', open);
    backdrop.hidden = !open;
    if (open) closeButton.focus();
    else { closeGroups(); toggle.focus(); }
  };
  toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
  closeButton.addEventListener('click', () => setOpen(false));
  backdrop.addEventListener('click', () => setOpen(false));
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
  }));
  root.addEventListener('keydown', event => {
    if (!root.hasAttribute('data-menu-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); setOpen(false); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
}
document.querySelectorAll('.ae-header').forEach(initialiseAEHeader);
document.addEventListener('shopify:section:load', event => initialiseAEHeader(event.target.querySelector('.ae-header')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
